export default {
  global: {
    title: 'Irrigation Calculator',
    cancel: 'cancel',
    close: 'close',
    create: 'create',
    back: `Back`,
    next: `Next`,
    ok: 'Ok',
    confirm: 'confirm'
  },
  home: {
    title: 'Welcome',
    description: 'Le calculateur d`irrigation est un outil de planification pour la mise en place d`équipement d`irrigation au champ.',
    link: 'Go to irrigation Calculator'
  },
  walktrough: [
    {
      step: `addWaterSource`,
      text: `Il faut d'abord ajouter la source d"eau.`,
    },
    {
      step: `defineWaterSourcePath`,
      text: `Il faut ensuite tracer le chemin de l'alimentation de la source d'eau.`,
    },
    {
      step: `drawIrrigationArea`,
      text: `Finalement, il faut définir la zone d'irrigation.`,
    }
  ],
  calculator: {
    form: {
      step1Title: `Define irrigation area`,
      warning: '*Fields, slope, solar orientations are relative to the north.',
      fieldLength: 'Length of the field (m)',
      fieldWidth: 'Width of the field (m)',
      fieldOrientation: 'Orientation of the field (deg)',
      bedsSpacing: 'Spacing between beds (m)',
      cropSpacing: 'Spacing betwwen crop (m)',
      distWaterSource: 'Distance between water source and the field(m)',
      slopeOrientation: 'Orientation of the slope (deg)',
      solarOrientation: 'Solar orientation (deg)',
      soilTypeLabel: 'Types of soil',
      soilTypes: ['clay', 'silt', 'sand', 'gravel'],
      cropTypeLabel: 'Type of crops',
      cropTypes: ["Conventional market gardener", "Fruit tree", `Intensive organic market gardening`],
      irrigationTypesLabel: 'Type of irrigation system',
      irrigationTypes: [`drip irrigation`, `sprinkler irrigation`],
      plantingMethod: 'Planting method',
      waterConsumption: 'Water consuptiom per week (pc/w)',
      step2Title: `Define the irrigation system`,
      waterSourceTypeLabel: `Whater source`,
      waterSourceTypes: [],
      waterSourcePipeDiameter: `Diameter of the water source pipe (pc)`,
      minimalPressure: `Minimal Pressure (p.s.i)`,
      maximumPressure: `Maximum Pressure (p.s.i)`,
      doYouHaveAPump: `Do you have a pump ?`,
      pumpModel: `What is your pump model ?`,
      pumpPreference: `Whould you prefer a electric or gas pump ?`,
      pumpPreferenceTypes: ['Essence', 'Electric'],
      yesNo: ['yes', 'no']
    },
    title: 'Calculator',
    sendToRepresentative: "Send to representative",
    steps: ['Select irrigation area', 'Define your irrigation system', 'Order your irrigation plan'],
  },
  orderForm: {
    billingAddress: 'Billing address',
    client: {
      name: 'Name',
      address: 'Address',
      city: 'City',
      province: 'Province',
      zipCode: 'Zip Code',
      phone: 'Phone',
      email: 'Email'
    },
    submit: 'Submit',
    question: `Do the field of the address is the same has the billing address?`
  },
  orderConfirmation: {
    title: 'This is our recommandation',
    action: `Communicate with a representative`,
    input: `recipient@email.com`,
    fail: `Fail to send email`
  },
  orderModal: {
    btnCancel: `Cancel`,
    btnSend: `Send`,
    text: 'A email containing the details will be send to your email.',
    title: 'Confirm your email',
    emailSendWithSucces: "Courriel envoyé avec succès",
    succes: `Send email with success`,
    fail: `Fail to send email`
  },
  checkout: {
    title: 'Checkout'
  }
}
